import React, {useEffect, useState} from 'react';
import {Backdrop, Button, Fade, Grid, Modal} from "@mui/material";
import NautilusTextInput from "../../Common/NautilusTextInput";

const GuestFormTransaction = ({handleForm,customer}) => {
    return (
        <form className={'loginCustomerForm'} noValidate autoComplete="off">
            <Grid container direction="row" justify="center" alignItems="center"
                  style={{paddingTop: 30, paddingBottom: 30}}>
                <Grid item sm={6} xs={12} style={{padding: 10}}>
					<NautilusTextInput fullWidth name="firstname" value={customer['firstname']}
									onChange={handleForm} label="First Name" variant="outlined"/>
				</Grid>
				<Grid item sm={6} xs={12} style={{padding: 10}}>
					<NautilusTextInput fullWidth name="lastname" value={customer['lastname']}
									onChange={handleForm} label="Last Name" variant="outlined"/>
				</Grid>
				<Grid item sm={6} xs={12} style={{padding: 10}}>
					<NautilusTextInput fullWidth name="email" value={customer['email']}
									onChange={handleForm} label="Email" variant="outlined"/>
				</Grid>
				<Grid item sm={6} xs={12} style={{padding: 10}}>
					<NautilusTextInput fullWidth name="telephone" value={customer['telephone']}
									onChange={handleForm} label="Telephone" variant="outlined"/>
				</Grid>
            </Grid>
        </form>
    );
};

export default GuestFormTransaction;
